<template>
    <div id="overlay">
        <div class='dialog-wrap'>
            <div class='icon-dialog-top' ref="defaultScrollTop">
                <div class='dialog_title'>アイコンの説明</div>
                <div class='table-back-ground'>
                    <div class="icon-explanation-body">
                        <div class="col-lg" v-for="(iconRec, name) in iconList" :key="name">
                            <div class="tableheader text-center" v-if="name === 'meal_flag'">食事</div>
                            <div class="tableheader text-center" v-if="name === 'cart_code'">カート</div>
                            <div class="tableheader text-center" v-if="name === 'guarantee_code'">サム保証</div>
                            <div class="tableheader text-center" v-if="name === 'caddie_flag'">キャディー</div>
                            <div class="tableheader text-center" v-if="name === 'round_type'">ラウンド</div>
                            <div class="tableheader text-center" v-if="name === 'accommodation_flag'">宿泊</div>
                            <div class="tableheader text-center" v-if="name === 'approval_flag'">組合せ</div>
                            <div class="td-icon"
                                v-for="icon in iconRec"
                                :key="icon.reserve1"
                                :class="icon.empty"
                            >
                                    <div :class="icon.reserve1" class="icon_class icon_sp"></div>
                                    <div class="icon-name-class">{{ icon.code_name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="reserve-status">
                    <div>
                        <div align="center">
                            <div class="tableheader tableheader-spmr">予約可能状況</div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex">
                            <div class='td-reserve-icon'>
                                <table class="icon-table fist_table">
                                    <tr>
                                        <td class='reserve-icon'>●</td>
                                        <td class='reserve-text' style='padding-top:7px;'>リアルタイム予約可能</td>
                                    </tr>
                                    <tr>
                                        <td class='reserve-icon share-icon'>○</td>
                                        <td class='reserve-text' style='padding-top:7px;'>組合せ予約可能</td>
                                    </tr>
                                    <tr class="pc_none">
                                        <td class='reserve-icon'>□</td>
                                        <td class='reserve-text' style='padding-top:7px;'>リクエスト予約可能</td>
                                    </tr>
                                    <tr class="pc_none">
                                        <td class='reserve-icon'>-</td>
                                        <td class='reserve-text' style='padding-top:7px;'>枠なし</td>
                                    </tr>
                                </table>
                            </div>
                            <div class='td-reserve-icon sp_none'>
                                <table class='icon-table'>
                                    <tr>
                                        <td class='reserve-icon'>□</td>
                                        <td class='reserve-text' style='padding-top:7px;'>リクエスト予約可能</td>
                                    </tr>
                                    <tr>
                                        <td class='reserve-icon'>-</td>
                                        <td class='reserve-text' style='padding-top:7px;'>枠なし</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dialog-wrap__btnArea py-4 my-0 bg-white">
                    <button class="bluebackbutton dialogBtn" v-on:click="onClose">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GET_CODE_KEY_LIST } from '../../../constants/codelist';

export default {
    components: {
    },
    data () {
        return {
            // PC版のアイコンの縦表示最大数
            maxIconNo: 0,
            iconList: [],
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize() {

        },
        /** ----------------------------------------------
         * 画面表示処理
         * ---------------------------------------------- */
        async open() {
            var me = this;
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.query({
                query: GET_CODE_KEY_LIST,
                variables: {
                    codeKeyList: ["meal_flag",
                                  "cart_code",
                                  "guarantee_code",
                                  "caddie_flag",
                                  "round_type",
                                  "accommodation_flag",
                                  "approval_flag"]
                }
            }).then(res => {
                me.setIcon(res.data.GetCodeListByKeys.CodeKeyRecList);
                me.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                const message = error.message.split(':');
                me.$store.commit("loading/setIsLoading", false);
            });

        },
        /** ----------------------------------------------
         * アイコン設定処理
         * 　アイコン表示用の配列を作成する
         * ---------------------------------------------- */
        setIcon(codeKeyRecList) {
            this.iconList = {};
            // アイコンの最大表示数を取得
            codeKeyRecList.forEach(ele => {
                if (ele.codeKey === 'meal_flag') {
                    this.iconList['meal_flag'] = ele.codeRec;
                    if (this.maxIconNo < this.iconList['meal_flag'].length) {
                        this.maxIconNo = this.iconList['meal_flag'].length;
                    }
                } else if (ele.codeKey == 'cart_code') {
                    this.iconList['cart_code'] = ele.codeRec;
                    if (this.maxIconNo < this.iconList['cart_code'].length) {
                        this.maxIconNo = this.iconList['cart_code'].length;
                    }
                } else if (ele.codeKey == 'guarantee_code') {
                    this.iconList['guarantee_code'] = ele.codeRec;
                    if (this.maxIconNo < this.iconList['guarantee_code'].length) {
                        this.maxIconNo = this.iconList['guarantee_code'].length;
                    }
                } else if (ele.codeKey == 'caddie_flag') {
                    this.iconList['caddie_flag'] = ele.codeRec;
                    if (this.maxIconNo < this.iconList['caddie_flag'].length) {
                        this.maxIconNo = this.iconList['caddie_flag'].length;
                    }
                } else if (ele.codeKey == 'round_type') {
                    this.iconList['round_type'] = ele.codeRec;
                    if (this.maxIconNo < this.iconList['round_type'].length) {
                        this.maxIconNo = this.iconList['round_type'].length;
                    }
                } else if (ele.codeKey == 'accommodation_flag') {
                    this.iconList['accommodation_flag'] = ele.codeRec;
                    if (this.maxIconNo < this.iconList['accommodation_flag'].length) {
                        this.maxIconNo = this.iconList['accommodation_flag'].length;
                    }
                } else if (ele.codeKey == 'approval_flag') {
                    this.iconList['approval_flag'] = ele.codeRec;
                    if (this.maxIconNo < this.iconList['approval_flag'].length) {
                        this.maxIconNo = this.iconList['approval_flag'].length;
                    }
                }
            });

            // 最大表示数分の表示枠を作成する
            codeKeyRecList.forEach(ele => {
                if (ele.codeKey === 'meal_flag') {
                    this.setArray(this.iconList['meal_flag'], this.iconList['meal_flag'].length);
                } else if (ele.codeKey == 'cart_code') {
                    this.setArray(this.iconList['cart_code'], this.iconList['cart_code'].length);
                } else if (ele.codeKey == 'guarantee_code') {
                    this.setArray(this.iconList['guarantee_code'], this.iconList['guarantee_code'].length);
                } else if (ele.codeKey == 'caddie_flag') {
                    this.setArray(this.iconList['caddie_flag'], this.iconList['caddie_flag'].length);
                } else if (ele.codeKey == 'round_type') {
                    this.setArray(this.iconList['round_type'], this.iconList['round_type'].length);
                } else if (ele.codeKey == 'accommodation_flag') {
                    this.setArray(this.iconList['accommodation_flag'], this.iconList['accommodation_flag'].length);
                } else if (ele.codeKey == 'approval_flag') {
                    this.setArray(this.iconList['approval_flag'], this.iconList['approval_flag'].length);
                }
            });
        },
        /** ----------------------------------------------
         * 配列に空のオブジェクトを挿入
         * ---------------------------------------------- */
        setArray (array, length) {
            if (length === this.maxIconNo) {
                return;
            }
            array.push({
                code: '',
                code_name: '',
                empty: 'empty'
            });

            this.setArray(array, array.length);
        },
        /** -------------------------------------------------------------------
         * モーダル内のスクロール位置リセット処理
         * (閉じるボタン押下後、再度モーダルを開いた時にスクロール位置が残るのを防ぐ)
         * ------------------------------------------------------------------- */
        scrollChange () {
            this.$refs.defaultScrollTop.scrollTop = 0;
        },
        /** ----------------------------------------------
         * 閉じるボタン処理
         * ---------------------------------------------- */
        onClose() {
            this.$emit('closeIconDialog');
        }
    }
}

</script>

<style scoped>
.pc_none {
    display: none;
}
.sp_none {
    display: table-row;
}
.dialog-wrap {
    overflow-x: hidden;
}

@media screen and (max-width: 896px) {
    .pc_none {
        display: table-row;
    }
    .sp_none {
        display: none;
    }
    .tableheader-spmr {
        margin-right: 7px;
    }
}
</style>

